'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Link } from 'foundations-components/transitional/components/Link';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FormLabelWithHelpLink extends Component {
  render() {
    const {
      primaryText,
      linkText,
      onLinkClick,
      required
    } = this.props;
    return /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      align: "baseline",
      justify: "between",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        required: required,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: primaryText
        })
      }), linkText ? /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(Link, {
          onClick: onLinkClick,
          "data-test-id": this.props['data-test-id'],
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: linkText
          })
        })
      }) : null]
    });
  }
}
FormLabelWithHelpLink.defaultProps = {
  onLinkClick: () => {}
};
FormLabelWithHelpLink.propTypes = {
  primaryText: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  onLinkClick: PropTypes.func,
  required: PropTypes.bool,
  ['data-test-id']: PropTypes.string
};